import { useState, useEffect } from "react";
import { Outlet, Navigate, Link } from "react-router-dom";
import { loadFestivalData } from "../../services/dataService";
import { adminVerifySecret } from "../../services/adminDataService";

export const loadAdminData = async () => {
  await loadFestivalData();
  return null;
};

export const AdminLayout = () => {
  const token = sessionStorage.getItem("admin_token");
  const [isValid, setIsValid] = useState<boolean | null>(null);

  useEffect(() => {
    if (!token) {
      setIsValid(false);
      return;
    }

    let isMounted = true;
    const verify = async () => {
      try {
        const ok = await adminVerifySecret(token);
        if (isMounted) {
          setIsValid(ok);
          if (!ok) {
            sessionStorage.removeItem("admin_token");
          }
        }
      } catch (err) {
        if (isMounted) {
          setIsValid(false);
          sessionStorage.removeItem("admin_token");
        }
      }
    };

    verify();

    return () => {
      isMounted = false;
    };
  }, [token]);

  if (!token || isValid === false) {
    return <Navigate to="/admin/login" replace />;
  }

  if (isValid === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-text">
        <div className="text-center space-y-3">
          <p className="text-muted">Verifying admin access...</p>
          <div className="w-8 h-8 border-2 border-main border-t-transparent rounded-full animate-spin mx-auto"></div>
        </div>
      </div>
    );
  }

  const logout = () => {
    sessionStorage.removeItem("admin_token");
    window.location.href = "/admin/login";
  };

  return (
    <div className="min-h-screen bg-background text-text">
      <header className="bg-background-accent border-b border-border p-4 flex justify-between items-center shadow-md">
        <Link
          to="/admin"
          className="font-bold text-xl text-main hover:text-accent-hover transition-colors"
        >
          Tilos Maraton Admin
        </Link>
        <div className="flex gap-4 items-center">
          <Link
            to="/"
            className="text-sm text-accent hover:text-accent-hover transition-colors underline"
          >
            Public Site
          </Link>
          <button
            type="button"
            onClick={logout}
            className="text-sm bg-card hover:bg-card-hover text-text border border-border px-3 py-1.5 rounded transition-all cursor-pointer"
          >
            Logout
          </button>
        </div>
      </header>
      <main className="p-4 max-w-7xl mx-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
